import React from 'react'
import Buttons from './components/Buttons';
import SearchForm from './components/SearchForm';
import Stories from './components/Stories';


function App() {
  return (
    <>
      <SearchForm />
      <Buttons />
      <Stories />
    </>
  );
}

export default App;
